module.exports = __webpack_public_path__ + "img/00023.42bae5ea.webp";